import LoadingContent from "./loading-content";

export default LoadingContent;
